import React from 'react';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import styles from './styles.module.css';

const ServiceCard = ({
    service: {
        id,
        name,
        photo: {url: photoUrl}={}
    } = {}
}) => (
    <div 
        key={id}
        className={styles.serviceCard}>
        <Link to={`/servicos/${id}`}>    
            <div className={styles.imageWrapper}>
                <div 
                    className={classnames(styles.serviceImage, styles.rotateBox)}
                    style={{
                        backgroundImage: `url('${photoUrl}')`
                    }}>
                </div>
            </div>
            <div className={styles.serviceCardName}>
                {name}
            </div>
        </Link>
    </div>

);

export default ServiceCard;